import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

// components
import Lobby from './lobby/Lobby'
import Rules from './lobby/Rules'
import Join from './lobby/Join'
import New from './lobby/New'
import Game from './game/Game'
import NotFound from './misc/NotFound'
import { PagesWrapper } from './styles'

const Routes = (props) => (
  <TransitionGroup component={PagesWrapper}>
    <CSSTransition
      {...props}
      classNames="page"
      timeout={150}
      mountOnEnter={true}
      unmountOnExit={true}
      key={props.location.pathname}
    >
    <ScrollToTop>
      <Switch>
        <Route exact path="/" render={routeProps => <Lobby {...props} {...routeProps} />} />
        <Route path="/rules" component={Rules} />
        <Route path="/join" component={Join} />
        <Route path="/new" component={New} />
        <Route path="/game/:gameId" render={routeProps => <Game gameId={routeProps.match.params.gameId} {...props} {...routeProps} />} />
        <Route component={NotFound} />
      </Switch>
    </ScrollToTop>
    </CSSTransition>
  </TransitionGroup>
)

// https://reacttraining.com/react-router/web/guides/scroll-restoration
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }
  render() {
    return this.props.children
  }
}

export default withRouter(Routes)



// WEBPACK FOOTER //
// ./src/views/Routes.jsx